<template>
  <div class="recent">
    <div class="columns">
      <div class="column is-three-fifths">
        <div class="post">
          <div v-if="data.length" class="content">
            <tweet
                v-for="(tweet, index) in data"
                :data="tweet"
                :clickable="true"
                :key="tweet.id + '-' + index"
                :show-tweet-actions="true"
            ></tweet>
            <div class="block mt-4">
              <b-button
                  @click="getOlder"
                  type="is-primary"
                  icon-left="angle-double-down"
                  outlined expanded
                  :disabled="isLoadingOld">Load more
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="notification">
          <p class="block">
            <strong>Recent</strong> lists all your standalone tweets.
            It excludes any retweets, replies, or tweets in a thread
            after the first one. This gives you a single place where
            you can quickly find your recent threads.
          </p>
          <p class="block">
            If you want to see your profile with all your replies, retweets and quotes in it,
            check out the
            <router-link to="/app/timelines/you" class="has-text-link"><strong>You</strong> timeline.</router-link>
          </p>
          <div class="block">
            <b-button
                @click="getData"
                type="is-primary"
                icon-left="sync"
                outlined expanded
                :disabled="$store.state.app.loading > 0">Load new
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tweet from "../../components/tweet/Tweet";
import tweets from "../../api/tweets";

export default {
  name: "Recent",
  components: {Tweet},
  data() {
    return {
      data: null,
      isLoadingOld: false
    }
  },
  computed: {
    activeAccountIndex() {
      return this.$store.state.auth.activeAccountIndex
    }
  },
  created() {
    this.getData()
  },
  watch: {
    '$route': 'getData',
    activeAccountIndex: 'getData',
  },
  methods: {
    getData() {
      this.data = []
      if (!this.$store.getters.isLoggedIn) return
      tweets.timeline('recent').then(response => {
        this.data = response.data
      }).catch(err => {
      })
    },

    getOlder() {
      if (this.data) {
        this.isLoadingOld = true
        let last_tweet = this.data.slice(-1)[0]
        tweets.timeline('recent', {max_id: last_tweet.retweeted_id || last_tweet.id}).then(response => {
          this.data.push(...response.data)
        })
        this.isLoadingOld = false
      }
    }
  }
}
</script>

